import { OUT_OF_RANGE_DROPDOWN_ITEM_INDEX } from '../constants'

export function getInputType (props) {
  return props.autocomplete ? 'text' : 'button'
}

function isUntouched (props, state) {
  return !props.value && !state.focused
}

export function canDisplayPlaceholder (props, state) {
  return !!props.placeholder && props.autocomplete && isUntouched(props, state)
}

function getDefaultedNewValue (props, value) {
  return value || props.value
}

function unableToSubsetOptions (props, newValue) {
  return !props.autocomplete || !newValue
}

function getSubsetOfAvailableOptions (props, newValue) {
  let availableOptions = []
  for (let i = 0; i < props.options.length; i++) {
    if (props.options[i].toLowerCase().indexOf(newValue.toLowerCase()) !== -1) {
      availableOptions.push(props.options[i])
    }
  }
  return availableOptions
}

export function getAvailableOptions (props, value) {
  const newValue = getDefaultedNewValue(props, value)
  if (unableToSubsetOptions(props, newValue)) return props.options
  return getSubsetOfAvailableOptions(props, newValue)
}

export function hasAvailableOptions (props, value) {
  return getAvailableOptions(props, value).length > 0
}

export function autoCapitaliseValue (props, value) {
  for (let i = 0; i < props.options.length; i++) {
    if (props.options[i].toLowerCase() === value.toLowerCase()) {
      return props.options[i]
    }
  }
  return value
}

export function valueIsAvailable (props) {
  for (let i = 0; i < props.options.length; i++) {
    if (props.options[i].toLowerCase() === props.value.toLowerCase()) {
      return true
    }
  }
  return false
}

export function validOptionFocused (state) {
  return state.dropdownItemFocused !== OUT_OF_RANGE_DROPDOWN_ITEM_INDEX
}
